import React from "react";
import { Route, Redirect } from "react-router-dom";
import { authUserUId } from "../api/FirebaseAPI";

export class AuthUserRoute extends React.Component {
  render() {
    console.log("AuthUserRoute")
    const val = authUserUId();
    console.log(val)
    const { component: Component, ...rest } = this.props
    return (
      <Route {...rest} render={props => {
        if (this.props.isAuthorising) return <div>Loading...</div>
        return val
          ? <Component {...this.props} />
          : <Redirect to='/unauthorised' />
      }} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/AuthUserRoute.js